import { UnsafeScreenRoot } from "types";
import { AdminRoot } from "types/Screen";

export const AdminRootDefinition: UnsafeScreenRoot = {
  name: AdminRoot,
  routePath: ["/admin/*"],
};
